/*  ========================================================================
    # Component - Testimonials
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';

// Import Sliders
import TestimonialSliderSimple from './TestimonialSliderSimple.jsx';
import TestimonialSliderLarge from './TestimonialSliderLarge.jsx';

const Testimonials = ({ variant, testimonials }) => {
  return (
    <div className='container'>
      <div className='s-products__wrapper'>
        {variant === '8.0' && (
          <TestimonialSliderSimple testimonials={testimonials} />
        )}
        {variant === '8.1' && (
          <TestimonialSliderLarge testimonials={testimonials} />
        )}
      </div>
    </div>
  );
};

Testimonials.propTypes = {
  variant: PropTypes.string,
  testimonials: PropTypes.array
};

export default Testimonials;
